async function loadDefaultPage() {
  const defaultPageUrl = "/pages/dados-pessoais";
  const defaultLink = document.querySelector(
    '.sidebar .menu a[data-page="/pages/dados-pessoais"]'
  );
  if (defaultLink) setActiveLink(defaultLink);

  try {
    const shouldRetryLocationSelection = sessionStorage.getItem("pendingLocationSelectionAfterCompanyChange") === "true";

    if (!shouldRetryLocationSelection) {
      sessionStorage.removeItem("pendingLocationSelectionAfterCompanyChange");
      sessionStorage.removeItem("pendingCurrentCompanyId");
      sessionStorage.removeItem("pendingCurrentLocationId");
      sessionStorage.removeItem("companySyncRetryCount");
    }

    const pendingCompanyId = sessionStorage.getItem("pendingCurrentCompanyId");
    const retryCount = Number(sessionStorage.getItem("companySyncRetryCount") || "0");
    const currentCompanyMatchesPending = !pendingCompanyId || String(globalCompanyId) === String(pendingCompanyId);

    if (pendingCompanyId && !currentCompanyMatchesPending && retryCount < 1) {
      sessionStorage.setItem("companySyncRetryCount", String(retryCount + 1));
      window.location.replace(`/pages/minha-conta?company-sync=${Date.now()}`);
      return;
    }

    if (pendingCompanyId && !currentCompanyMatchesPending) {
      return;
    }

    if (shouldRetryLocationSelection && !currentCompanyMatchesPending) {
      return;
    }

    const locationSelectionResult = await setLocationAsCurrent();
    if (shouldRetryLocationSelection && locationSelectionResult !== "modal") {
      sessionStorage.removeItem("pendingLocationSelectionAfterCompanyChange");
    }

    if (currentCompanyMatchesPending && pendingCompanyId) {
      sessionStorage.removeItem("companySyncRetryCount");
    }
  } catch (error) {
    console.error(error);
  }

  try {
    const response = await fetch(defaultPageUrl);
    if (!response.ok) throw new Error("Erro ao carregar a página padrão.");

    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const content = doc.querySelector("#page-account");

    const pageContent = document.getElementById("page-content");
    pageContent.innerHTML = content
      ? content.innerHTML
      : "<p>Conteúdo não encontrado.</p>";
  } catch (error) {
    console.error(error);
    document.getElementById("page-content").innerHTML =
      "<p>Erro ao carregar o conteúdo padrão.</p>";
  }
}

async function loadPersonalData() {
  try {
    const organizations = await fetchWithCache(
      "personalData",
      getOrganizationData,
      globalCustomerId
    );
    renderPersonalData(organizations.items);
  } catch (error) {
    console.error(error);
  }
}

function renderPersonalData(organizations) {
  const organization = organizations.find(
    (org) => org.shopifyCompanyId === `gid://shopify/Company/${globalCompanyId}`
  );

  const billingAddressContainerElement = document.getElementById(
    "billing-address-container"
  );
  const billingAddressText = document.querySelector(
    "#billing-address-container p"
  );

  if (!organization || !billingAddressContainerElement || !billingAddressText) {
    return;
  }

  billingAddressContainerElement.style.display = "block";

  const address = organization.billingAddress;

  const capitalize = (word) =>
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

  const formatField = (field) => field.split(" ").map(capitalize).join(" ");

  const address1 = formatField(address.address1 || "");
  const address2 = address.address2 || "";
  const city = formatField(address.city || "");
  const address3 = address.address3 ? formatField(address.address3) : "";
  const state = address.state.toUpperCase();
  const zip = address.postalCode;

  const formattedAddress = `${address1}, ${address2} - ${city}, ${address3}, ${city}/${state}, ${zip
    .replace(/\D/g, "")
    .replace(/^(\d{5})(\d{3})$/, "$1-$2")}`;
  billingAddressText.textContent = formattedAddress;
}
